exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".private-note {\n    background-color: #fef2a4;\n    \n}\n\n.private-note .msg, \n.private-note .message-info-td .message-time,\n.private-note .message-info-td .message-deliver {\n    color: #1a1d1e;\n}\n\n.message-translate {\n    border-top: 1px solid #bfbfbf;\n    color: #bfbfbf;\n    margin-top: 8px;\n}\n\n.message-translate span {\n    font-size: 12px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/MessageRenderer/MessageRenderer.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/MessageRenderer/MessageRenderer.css
// module chunks = 120